var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUserCircle24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.505 5.875c0 2.48 2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5-4.5 2.02-4.5 4.5M6.455 22.625h11.09c1.19 0 2.18-.88 2.3-2.06.15-1.46.15-3.26.15-4.34 0-2.94-2.98-5.23-6.78-5.23h-2.42c-3.74 0-6.79 2.34-6.79 5.22 0 1 0 2.87.15 4.34a2.3 2.3 0 0 0 2.3 2.07"
})));
export default SvgIcUserCircle24;